import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router) // 调用路由
export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '../views/Login')
    },
    // {
    //   path: '/home', // 我的账户
    //   name: 'home',
    //   component: () => import(/* webpackChunkName: "home" */ '../views/Home')
    // },
    // {
    //   path: '/accountcenter', // 我的账户 > 账户中心
    //   name: 'accountcenter',
    //   component: () => import(/* webpackChunkName: "accountcenter" */ '../views/AccountCenter')
    // },
    {
      path: '/404',
      name: '404',
      component: () => import(/* webpackChunkName: "404" */'../views/Redirect/404.vue')
    },
    {
      path: '/403',
      name: '403',
      component: () => import(/* webpackChunkName: "403" */'../views/Redirect/403.vue')
    },
    {
      path: '/500',
      name: '500',
      component: () => import(/* webpackChunkName: "500" */'../views/Redirect/500.vue')
    },
    // {
    //   path: '/financing', // 我的融资
    //   name: 'financing',
    //   component: () => import(/* webpackChunkName: "financing" */'../views/financing/myFinancing.vue')//我的融资
    // },
    // {
    //   path: '/financingApplication', // 我的融资 -> 融资申请 -> 详情
    //   name: 'financingApplication',
    //   component: () => import(/* webpackChunkName: "financingApplication" */'../views/financing/financingApplication.vue')
    // },
    // {
    //   path: '/financingAppliForm', // 我的融资 -> 融资贷款 -> 详情、还款、贴现提取
    //   name: 'financingAppliForm',
    //   component: () => import(/* webpackChunkName: "financingApplication" */'../views/financing/financingAppliForm.vue')
    // },
    // {
    //   path: '/financingDetails',
    //   name: 'financingDetails',
    //   component: () => import(/* webpackChunkName: "financingDetails" */'../views/financing/financingDetails.vue')
    // },
    // {
    //   path: '/bonusApply', //我的账户->分红管理->申请分红
    //   name: 'bonusApply',
    //   component: () => import(/* webpackChunkName: "bonusApply" */'../views/bonus/bonusApply.vue')
    // },
    // {
    //   path: '/bonusLists', // 我的账户->分红管理
    //   name: 'bonusLists',
    //   component: () => import(/* webpackChunkName: "bonusLists" */'../views/bonus/bonusLists.vue')
    // },
    // {
    //   path: '/bonusDetail', // 我的账户->分红管理->详情（分红单）、 流水明细详情
    //   name: 'bonusDetail',
    //   component: () => import(/* webpackChunkName: "bonusDetail" */'../views/bonus/bonusDetail.vue')
    // },
    // {
    //   path: '/cashApply', // 我的账户 > Z币提现申请
    //   name: 'cashApply',
    //   component: () => import(/* webpackChunkName: "cashApply" */'../views/bank/cashApply.vue')
    // },
    // {
    //   path: '/extractCrashLists', // 我的账户 > 提现明细（提现记录）
    //   name: 'extractCrashLists',
    //   component: () => import(/* webpackChunkName: "extractCrashLists" */'../views/extractCrash/extractCrashLists.vue')
    // },
    // {
    //   path: '/extractCrashDetail', // 我的账户 > 提现明细（提现记录）> 提现详情
    //   name: 'extractCrashDetail',
    //   component: () => import(/* webpackChunkName: "extractCrashDetail" */'../views/extractCrash/extractCrashDetail.vue')
    // },
    // {
    //   path: '/flowLists', // 我的账户 > 流水明细（账户流水）
    //   name: 'flowLists',
    //   component: () => import(/* webpackChunkName: "flow" */'../views/flow/flowLists.vue')
    // },
    // {
    //   path: '/bankList', // 我的账户 > 银行账号管理
    //   name: 'bankList',
    //   component: () => import(/* webpackChunkName: "bankList" */'../views/bank/bankList.vue')
    // },
    // {
    //   path: '/chaincount', // 我的账户 > 账户中心 > 上链数据（区块链统计）
    //   name: 'chaincount',
    //   component: () => import(/* webpackChunkName: "chaincount" */'../views/ChainCount')
    // },
    // {
    //   path: '/chainDetails', // 我的账户 > 账户中心 > 上链数据（区块链统计）> 详情
    //   name: 'chainDetails',
    //   component: () => import(/* webpackChunkName: "chainDetails" */'../views/ChainCount/chainDetails')
    // },
    // {
    //   path: '/contractManage',// 合同管理(融资方)
    //   name: 'contractManage',
    //   component: () => import(/* webpackChunkName: "contractManage" */'../views/contract/contractManage')
    // },
    {
      path: '/financingFundList', // 资金锁定 融资资金锁定审核
      name: 'financingFundList',
      component: () => import(/* webpackChunkName: "financingFundList" */'../views/financingFund/list.vue')
    },
    {
      path: '/financingFundDetail', // 资金锁定->融资申请书
      name: 'financingFundDetail',
      component: () => import(/* webpackChunkName: "financingFundDetail" */'../views/financingFund/detail.vue')
    },

    {
      path: '/afterLoanList', // 贷后跟踪
      name: 'afterLoanList',
      component: () => import(/* webpackChunkName: "afterLoanList" */'../views/loan/afterLoan/afterLoanList')
    },
    {
      path: '/loanDetail', // 贷后跟踪、贷款发放 -> 船期状态之后的详情
      name: 'loanDetail',
      component: () => import(/* webpackChunkName: "afterLoanDetail" */'../views/loan/afterLoan/loanDetail.vue')
    },
    {
      path: '/newriskmanage', // 申请风控
      name: 'newriskmanage',
      component: () => import(/* webpackChunkName: "RiskManage" */'../views/RiskManage')
    },
    {
      path: '/allorders', // 全部订单
      name: 'allorders',
      component: () => import(/* webpackChunkName: "AllOrders" */'../views/AllOrders')
    },
    {
      path: '/rongzisqs', // 申请风控->审核、查看
      name: 'rongzisqs',
      component: () => import(/* webpackChunkName: "rongzisqs" */'../views/RiskManage/rongzisqs')
    },
    {
      path: '/riskAssessment', // 申请风控->风险评估
      name: 'RiskAssessment',
      component: () => import(/* webpackChunkName: "rongzisqs" */'../views/RiskManage/RiskAssessment')
    },
    {
      path: '/riskAssessmentDetail', // 申请风控->风险评估详情
      name: 'RiskAssessmentDetail',
      component: () => import(/* webpackChunkName: "rongzisqs" */'../views/RiskManage/RiskAssessmentDetail')
    },
    {
      path: '/riskCoal', // 申请风控->风险评估煤炭
      name: 'RiskCoal',
      component: () => import(/* webpackChunkName: "rongzisqs" */'../views/RiskManage/RiskCoal')
    },
    {
      path: '/riskCoalDetail', // 申请风控->风险评估煤炭详情
      name: 'RiskCoalDetail',
      component: () => import(/* webpackChunkName: "rongzisqs" */'../views/RiskManage/RiskCoalDetail')
    },
    {
      path: '/financingExamineList', // 贷款发放列表
      name: 'financingExamineList',
      component: () => import(/* webpackChunkName: "financingExamineList" */'../views/finacingExamine/list.vue')
    },
    {
      path: '/financingExamineDetail', // 贷款发放详情
      name: 'financingExamineDetail',
      component: () => import(/* webpackChunkName: "financingExamineDetail" */'../views/finacingExamine/detail.vue')
    },
    {
      path: '/poolofmoney', // 资金池监控
      name: 'poolofmoney',
      component: () => import(/* webpackChunkName: "poolofmoney" */'../views/PoolOfMoney')
    },
    // {
    //   path: '/discountExtraction',// 贴现详情
    //   name: 'discountExtraction',
    //   component: () => import(/* webpackChunkName: "discountExtraction" */'../views/flow/discountExtraction')
    // },
    {
      path: '/messageCenter', // 消息通知
      name: 'messageCenter',
      component: () => import(/* webpackChunkName: "messageCenter" */'../views/MessageCenter')
    },
    {
      path: '/logisticMap', // 船运信息
      name: 'logisticMap',
      component: () => import(/* webpackChunkName: "logisticMap" */'../views/financingFund/logisticMap/index.vue')
    }
  ]
})
